import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Only on marketing home (`/`).
 * PWA reopen after Recents-kill cold-starts at start_url; if the user is still
 * logged in, send them to the dashboard so it doesn't look like a logout.
 * Leaves /login, /onboarding, /login-live untouched.
 */
export default function AuthRoute({ Component }: any) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.replace(/\/+$/, "") || "/";
    if (path !== "/") return;

    // const loggedIn = localStorage.getItem("loggedIn");
    // if (loggedIn) {
    //   navigate("/dashboard", { replace: true });
    // }
  }, [location.pathname, navigate]);

  return <Component />;
}
